<template>
  <div
    id="crewTrainingReschedule"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="crewTrainingRescheduleLabel"
    aria-hidden="true"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div
      class="modal-dialog"
      role="document"
    >
      <form
        class="modal-content"
        @submit.prevent="rescheduleCrewTraining"
      >
        <div class="modal-header row mr-0 ml-0">
          <div class="col col-sm-7">
            <h6
              class="modal-title font-weight-bolder"
              id="crewTrainingRescheduleLabel"
            >
              Reschedule Crew Training
            </h6>
          </div>
          <div class="col col-sm-5 text-right pr-0">
            <button
              data-dismiss="modal"
              aria-label="Close"
              class="btn btn-sm btn-xs btn-outline-secondary font-weight-bolder float-right"
              @click="clearCrewTraining"
              id="cancelRescheduleButton"
            >
              Cancel
            </button>

            <button
              type="submit"
              class="btn btn-sm btn-xs btn-outline-primary font-weight-bolder mr-1 float-right"
            >
              Save Schedule
            </button>
          </div>
        </div>

        <div class="modal-body">
          <div class="form-group form-row">
            <label
              class="col col-sm-3 col-form-label font-weight-bolder text-right pl-0"
              for="trainingProvider"
            >Training Provider:</label>
            <div class="col col-sm-9">
              <select
                id="trainingProvider"
                required
                class="form-control form-control-xs form-control-xxs select-center"
                @change="switchProvider"
              >
                <option :value="null">
                  --- SELECT TRAINING PROVIDER ---
                </option>
                <option
                  v-for="provider in crewTrainingProviders"
                  :key="provider.id"
                  :value="provider.id"
                  :selected="provider.id === formParams.trainingProviderId"
                >
                  {{ provider.code }}
                </option>
              </select>
            </div>
          </div>

          <div class="form-group form-row">
            <label
              class="col col-sm-3 col-form-label font-weight-bolder text-right"
              for="training"
            >Training:</label>
            <div class="col col-sm-9">
              <input
                type="text"
                id="training"
                readonly
                class="form-control form-control-xs form-control-xxs"
                :value="crewTraining.courseName"
              >
            </div>
          </div>

          <div class="form-group form-row">
            <label
              class="col col-sm-3 col-form-label font-weight-bolder text-right"
              for="trainingCenter"
            >Training Center:</label>
            <div class="col col-sm-9">
              <select
                required
                id="trainingCenter"
                class="form-control form-control-xs form-control-xxs select-center"
                @change="setScheduledTrainingCenter"
              >
                <option
                  v-for="(trainingCenter, index) in formParams.trainingCenters"
                  :key="trainingCenter.id"
                  :value="index"
                >
                  {{ trainingCenter.name }}
                </option>
              </select>
            </div>
          </div>

          <div class="form-group form-row">
            <label
              class="col col-sm-3 col-form-label font-weight-bolder text-right"
              for="trainingCenter"
            >Date:</label>
            <div class="col col-sm-9">
              <select
                class="form-control form-control-xs form-control-xxs select-center"
                required
                id="date"
                v-model="newCrewTrainingSchedule.trainingScheduleId"
                @change="checkCrewScheduleConflict"
              >
                <option :value="null">
                  --- SELECT DATE ---
                </option>
                <option
                  v-for="schedule in formParams.trainingCenterSchedules"
                  :key="schedule.id"
                  :value="schedule.id"
                >
                  {{ schedule.date_from | moment('D MMM YYYY') }} -
                  {{ schedule.date_to | moment('D MMM YYYY') }}
                </option>
              </select>
            </div>
          </div>

          <div
            class="card mb-2 mt-1"
            v-if="scheduleConflicts.length"
          >
            <div class="card-header font-weight-bold text-danger text-center p-2">
              CONFLICTS
            </div>
            <div class="card-body p-2">
              <div
                class="row"
                v-for="conflict in scheduleConflicts"
                :key="conflict.name"
              >
                <div class="col col-sm-3 font-weight-bold text-right">
                  COURSE:
                </div>
                <div class="col col-sm-9">
                  {{ conflict.name }}
                </div>
                <div class="col col-sm-3 font-weight-bold text-right">
                  DATE:
                </div>
                <div class="col col-sm-9">
                  {{ conflict.date_from | moment('DD MMM YYYY') }} - {{ conflict.date_to | moment('DD MMM YYYY') }}
                </div>
                <div class="col col-sm-3 font-weight-bold text-right">
                  TIME:
                </div>
                <div class="col col-sm-9">
                  {{ conflict.timeFrom | parseTime }} - {{ conflict.timeTo | parseTime }}
                </div>
                <hr class="hr-color m-1">
              </div>
            </div>
          </div>

          <div class="form-group form-row">
            <label
              class="col col-sm-3 col-form-label font-weight-bolder text-right"
              for="vessel"
            >VESSEL:</label>
            <div class="col col-sm-9">
              <select
                id="vessel"
                class="form-control form-control-xs form-control-xxs select-center"
                v-model="newCrewTrainingSchedule.endorsementId"
              >
                <option
                  v-if="crew.detail.endorsement"
                  selected
                  :value="crew.detail.endorsement.id"
                >
                  {{ crew.detail.endorsement.vessel.name }} | {{ crew.detail.endorsement.etd | moment('DD MMM YYYY') }}
                </option>

                <!--                                <option :value="null"> -&#45;&#45; SELECT VESSEL -&#45;&#45; </option>-->
                <!--                                <option v-for="vessel in vessels"-->
                <!--                                        :key="vessel.id"-->
                <!--                                        :selected="crew.detail.endorsement && crew.detail.endorsement.vessel && (crew.detail.endorsement.vessel.id === vessel.id)"-->
                <!--                                        :value="vessel.id"-->
                <!--                                >{{ vessel.name }} </option>-->
              </select>
            </div>
          </div>

          <div class="form-group form-row">
            <label
              class="col col-sm-3 col-form-label font-weight-bolder text-right"
              for="reason"
            >RESCHEDULING REASON:</label>
            <div class="col col-sm-9">
              <select
                required
                id="reason"
                class="form-control form-control-xs form-control-xxs select-center"
                v-model="newCrewTrainingSchedule.reason"
              >
                <option :value="null">
                  --- SELECT REASON ---
                </option>
                <option
                  v-for="(reason, index) in reasons"
                  :title="reason.description"
                  :key="reason.id"
                  :value="reason.id"
                >
                  {{ reason.name }}
                </option>
              </select>
            </div>
          </div>

          <div class="form-group form-row">
            <label
              class="col col-sm-3 col-form-label font-weight-bolder text-right"
              for="remarks"
            >Remarks:</label>
            <div class="col col-sm-9">
              <textarea
                rows="4"
                id="remarks"
                class="form-control form-control-xs"
                placeholder="TRAINING SCHEDULE REMARKS"
                v-model="newCrewTrainingSchedule.remarks"
                @input="capitalize($event, newCrewTrainingSchedule, 'remarks')"
              />
            </div>
          </div>

          <div class="form-group form-row">
            <div class="col col-sm-3 col-form-label font-weight-bolder text-right">
              ALLOWANCE:
            </div>
            <div class="col col-sm-1">
              <input
                type="checkbox"
                name="allowance"
                id="allowance"
                class="form-control form-control-xs"
                v-model="newCrewTrainingSchedule.allowance"
              >
            </div>
            <label class="col-sm-6 col-form-label font-weight-bolder">{{ newCrewTrainingSchedule.allowance? 'WITH ALLOWANCE' : 'NO ALLOWANCE' }}</label>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>

    import {mapGetters,mapActions} from 'vuex';
    import {formMixins} from '../../mixins/formMixins';

    export default {
        mixins:[ formMixins ],
        name: "CrewTrainingReschedule",
        data() {
            return{
                newCrewTrainingSchedule: {
                    crewTrainingId: null,
                    crewTrainingScheduleId: null,
                    trainingScheduleId: null,
                    vesselId: null,
                    allowance: false,
                    reason: null,
                    remarks: '',
                    endorsementId: null
                },
                vessels: [],
                reasons: [],
            }
        },
        methods: {
            ...mapActions([
                'getTrainingCentersByScheduledCourse',
                'findCrewTrainingPerProvider',
                'clearCrewTraining',
                'getVesselList',
                'rescheduleCrewTrainingOnCrew',
                'getReasons',
                'checkCrewScheduleConflict'
            ]),

            switchProvider(e) {
                this.formParams.trainingProviderId = parseInt(e.target.value);
                let crewId= this.formParams.crewId;
                let providerId = this.formParams.trainingProviderId;
                this.formParams.selectedCourseId = null;
                this.findCrewTrainingPerProvider({ crewId, providerId });
            },

            setScheduledTrainingCenter(e) {
                this.newCrewTrainingSchedule.trainingScheduleId = null;
                this.formParams.trainingCenterSchedules = this.formParams.trainingCenters[e.target.value].training_schedules
                    .filter(schedule => {
                        return schedule.date_from !== this.crewTraining.dateFrom && schedule.date_to !== this.crewTraining.dateTo
                    });
            },

            async rescheduleCrewTraining() {
                if(await this.confirmUpdateAlert('Are you sure you want to reschedule this schedule this crew training?')) {
                    this.newCrewTrainingSchedule.crewTrainingId = this.crewTraining.crewTrainingId;
                    this.newCrewTrainingSchedule.crewTrainingScheduleId = this.crewTraining.crewTrainingScheduleId;
                    if(this.crewTraining.allowance && !this.newCrewTrainingSchedule.allowance) {
                        if(!await this.confirmCreateAlert('This course has allowance but did not granted on this schedule, Are you sure you want to proceed?')) {
                            return false;
                        }
                    }
                    if(await this.rescheduleCrewTrainingOnCrew(this.newCrewTrainingSchedule)) {
                        this.successAlert('Crew Training Schedule Successfully Rescheduled', 'RESCHEDULE');
                        this.newCrewTrainingSchedule = {
                            crewTrainingId: null,
                            crewTrainingScheduleId: null,
                            trainingScheduleId: null,
                            vesselId: null,
                            allowance: false,
                            remarks: ''
                        };
                        document.getElementById('cancelRescheduleButton').click();
                    } else {
                        this.errorAlert(null, 'CREW TRAINING RESCHEDULE');
                    }
                }
            },
            async initializeData() {
                // this.vessels = await this.getVesselList();
                this.reasons = await this.getReasons();
                this.newCrewTrainingSchedule.endorsementId = this.crew.detail.endorsement ? this.crew.detail.endorsement.id : null;
            }
        },
        computed: {
            ...mapGetters([ 'crewTraining', 'formParams', 'crewTrainingProviders', 'scheduleConflicts', 'crew', 'crew' ]),
        },
        created() {
            this.initializeData();
        }
    }
</script>

<style scoped>

</style>
